import { render, staticRenderFns } from "./BtnPromotional.vue?vue&type=template&id=bf2cc376&scoped=true"
import script from "./BtnPromotional.vue?vue&type=script&lang=js"
export * from "./BtnPromotional.vue?vue&type=script&lang=js"
import style0 from "./BtnPromotional.vue?vue&type=style&index=0&id=bf2cc376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2cc376",
  null
  
)

export default component.exports